import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SiteServices } from '../../services/siteservices';
import { PaginationModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AlertModule } from 'ngx-bootstrap/alert';
import { RouteReuseStrategy } from '@angular/router';
import { MARKETING_ROUTER_PROVIDERS } from './marketing.routes';

import { CustomReuseStrategy } from '../common/route.reuse';

import { MarketingComponent } from './marketing.main';
import { Marketing } from './marketing.list';

import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { ProductDetailModule } from '../productdetail/productdetail.module';
import {
    ProviderHtmlMarketingElementsListComponent
} from "../providerhtmlmarketingelements/providerhtmlmarketingelements.list";

@NgModule({
    declarations: [MarketingComponent, Marketing, ProviderHtmlMarketingElementsListComponent],
    imports: [
        BrowserModule,
        MARKETING_ROUTER_PROVIDERS,
        FormsModule,
        HttpModule,
        ProductDetailModule,
        PaginationModule.forRoot(),
        AlertModule.forRoot(),
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        MDBBootstrapModule.forRoot(),
    ],
    providers: [
        SiteServices,
        { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    ],
    bootstrap: [MarketingComponent],
})
export class MarketingModule {}
